import type { HelpFile } from '../../types/help'
import { RehireReviewTestIds } from '../../../testids/RehireReviewTestIds'

export const rehireReviewHelp: HelpFile = {
  docPage: '/docs/admin/rehire-review',
  texts: {
    [RehireReviewTestIds.rehireReviewList]:
      'Queue of possible rehires — candidates appear when an inbound sync matches an incoming record against a TERMINATED identity.',
    [RehireReviewTestIds.rehireReviewLoading]: null,
    [RehireReviewTestIds.rehireReviewEmpty]:
      'No rehire candidates match the current filters.',
    [RehireReviewTestIds.colSourceConnector]:
      'Inbound connector that detected this potential rehire.',
    [RehireReviewTestIds.colMatchedIdentity]:
      'Existing TERMINATED identity the incoming record was matched against.',
    [RehireReviewTestIds.colNewEntryDate]:
      'Proposed new entry date from the incoming record.',
    [RehireReviewTestIds.colDetectedAt]:
      'When the connector first flagged this candidate.',
    [RehireReviewTestIds.colStatus]:
      'Decision state of this candidate — pending, accepted, or rejected.',
    [RehireReviewTestIds.colDecidedBy]:
      'Identity or connector that recorded the decision.',
    [RehireReviewTestIds.badgeDecidedByConnector]:
      'Decision was made automatically by the connector based on its matching rules, not by a human reviewer.',
  },
}
